import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { RefreshCw, XCircle } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 px-6 bg-slate-950 relative overflow-hidden" data-id="element-131">
      {/* Background decoration */}
      <div className="absolute right-0 top-1/4 w-96 h-96 bg-blue-900/10 rounded-full blur-[100px]" data-id="element-132" />

      <div className="max-w-4xl mx-auto" data-id="element-133">
        <FadeIn data-id="element-134">
          <div className="text-center mb-16" data-id="element-135">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-136">
              La verdad incómoda: <br data-id="element-137" />
              <span className="text-amber-500" data-id="element-138">
                despertarte no es el problema
              </span>
            </h2>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-139">
              Mucha gente se despierta en la noche y vuelve a dormir. Lo que
              convierte tu despertar en "insomnio horrible" es lo que pasa
              después.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={200} data-id="element-140">
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-16 text-slate-300 font-medium text-center md:text-left" data-id="element-141">
            <div className="bg-slate-900 px-6 py-4 rounded-lg border border-slate-800" data-id="element-142">
              Despertar
            </div>
            <div className="text-amber-500" data-id="element-143">→</div>
            <div className="bg-slate-900 px-6 py-4 rounded-lg border border-slate-800 text-amber-200" data-id="element-144">
              Interpretar peligro
            </div>
            <div className="text-amber-500" data-id="element-145">→</div>
            <div className="bg-slate-900 px-6 py-4 rounded-lg border border-slate-800 text-amber-200" data-id="element-146">
              Activar cuerpo
            </div>
            <div className="text-amber-500" data-id="element-147">→</div>
            <div className="bg-slate-900 px-6 py-4 rounded-lg border border-slate-800 text-red-300" data-id="element-148">
              Activar más
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={400} data-id="element-149">
          <div className="bg-slate-900/50 p-8 rounded-2xl border border-slate-800" data-id="element-150">
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-151">
              <div className="flex-1" data-id="element-152">
                <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-153">
                  <XCircle className="text-red-400" data-id="element-154" />
                  Por qué fallan los "tips" normales
                </h3>
                <p className="text-slate-300 mb-4" data-id="element-155">
                  Los tés, la melatonina y las meditaciones genéricas se quedan
                  cortos porque intentan sedarte sin apagar la alarma de
                  amenaza.
                </p>
                <p className="text-lg font-medium text-amber-400" data-id="element-156">
                  Tú no necesitas otro consejo bonito. Necesitas un sistema para
                  el momento crítico.
                </p>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}